document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.about-vault');
  const container = section?.querySelector('.about-vault__container');

  if (!section || !container) return;

  section.style.backgroundSize = '120% auto';
  section.style.backgroundPosition = 'center center';

  const updateParallax = () => {
    const rect = container.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {
      const scrollProgress = (windowHeight - rect.top) / (windowHeight + rect.height);
      const offset = scrollProgress * 70 - 30;
      section.style.backgroundPosition = `center calc(50% + ${offset}px)`;
    }
  };

  window.addEventListener('scroll', updateParallax);
  window.addEventListener('resize', updateParallax);
  updateParallax();
});
